import styled from 'styled-components';

import background from 'styles/assets/images/Connexion.png';

export default (Component) => styled(Component)`
  position: relative;
  min-height: 100vh;

  &::before {
    content: '';
    position: fixed;
    inset: 0;
    z-index: -1;
    background: url(${background});
    background-size: cover;
    background-attachment: fixed;
    background-position: center center;
    /* Intentional: warm filter to reduce blue cast. Do not remove — other devs may expect the original image tone. */
    filter: sepia(0.15) saturate(1.1);
  }

  .landing__background {
    text-align: center;
    width: 100%;
    padding: 40px;
  }

  .landing__logo {
    width: 100px;
    height: 100px;
  }

  .landing__logo-text {
    font-family: Montserrat;
    font-size: 24px;
    color: azure;
    display: block;
    font-weight: 600;
    margin-top: 15px;
    text-align: center;
  }

  .landing__label {
    font-size: 14px;
    color: azure;
    font-family: Montserrat;
    display: block;
    margin: 0;
    font-weight: 600;
    letter-spacing: 0.5px;
    margin-left: 10px;

    a {
      color: white;
    }
  }

  .landing__headline {
    color: #ffffff;
    font-weight: bold;
    display: block;
    width: 100%;
    font-size: 20px;
    margin-bottom: 10px;
    white-space: nowrap;
  }

  .landing__headline-decription {
    color: #ffffff;
    font-family: Montserrat;
    font-size: 14px;
    display: inline-block;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .landing_logout {
    color: #ffffff;
    font-family: Montserrat;
    font-size: 12px;
    letter-spacing: 0.15px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
  }

  .button-circular__icon {
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    height: 40px;
    width: 40px;
    background-color: #ff0066;
    border-radius: 40px;
    text-decoration: none;
    vertical-align: middle;
    display: inline-block;
  }

  .landing_logout-icon {
    top: 40px;
    position: absolute;
    right: 40px;
    cursor: pointer;
  }
  .icon-logout-landing:before {
    color: #f5f5f5;
    content: '\\e92f';
  }

  .landing__icon-yellow {
    background-color: #eddd0c;
    border-radius: 24px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    font-size: 11px;
    margin-right: 15px;
    display: inline-block;
  }

  .landing__icon-green {
    background-color: #35e687;
    border-radius: 24px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    margin-right: 15px;
    font-size: 11px;
    display: inline-block;
  }

  .landing__icon-blue {
    background-color: #63c8ff;
    border-radius: 24px;
    height: 24px;
    width: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 11px;
    margin-right: 15px;
    display: inline-block;
  }

  .landing__container {
    display: block;
    text-align: center;
  }

  .landing__container-label {
    display: block;
    text-align: left;
    margin-bottom: 10px;
  }

  .landing__provider {
    width: 100%;
    margin-top: 70px;
    max-width: 1020px;
    margin-left: auto;
    margin-right: auto;
  }

  .landing__provider-wrapper {
    flex-flow: nowrap;
    justify-content: space-between;
    display: flex;
  }

  .landing__provider-container {
    font-size: 10px;
    background-color: #1b74ab;
    border-radius: 20px;
    width: 240px;
    min-height: 140px;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    border-left: 4px solid transparent;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }

    &.landing__provider--deactivated {
      border-left: 4px solid #e74c3c;
      background-color: rgba(27, 116, 171, 0.65);

      .landing__temperatures-wrap {
        border-top-color: rgba(231, 76, 60, 0.4);
      }
    }

    .landing__provider-content {
      margin: 0 auto;
      display: flex;
      height: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: stretch;
      padding: 18px 20px;
      .landing__headline {
        height: 2.2em;
        min-height: 2.2em;
        white-space: nowrap;
        overflow: visible;
        margin-bottom: 0;
        text-align: left;
        display: inline-flex;
        align-items: center;
        max-width: 100%;
        transform-origin: left center;
      }
      .landing__temperatures-wrap {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid rgba(255, 255, 255, 0.25);
        width: 100%;
        flex-shrink: 0;
      }
      .landing__headline-temperatures {
        i {
          margin-right: 10px;
          &::before {
            height: 25px;
            width: 25px;
            line-height: 25px;
          }
        }
        width: 100%;
        text-align: left;
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .landing__disclaimer {
    margin-top: 15px;
    padding: 32px 28px;
    max-width: 610px;
    margin-left: auto;
    margin-right: auto;
    background-color: #1b74ab;
    border-radius: 16px;
    color: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .landing__disclaimer-text {
    margin: 0;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.02em;
    color: #fff;
    font-weight: 500;
    text-align: left;
  }

  .landing__disclaimer-title {
    font-weight: 900;
  }

  .landing__disclaimer-text a {
    color: #fff;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-weight: 600;
    transition: opacity 0.2s ease;
  }

  .landing__disclaimer-text a:hover {
    opacity: 0.9;
  }

  @media screen and (max-width: 768px) {
    .landing__disclaimer {
      padding: 24px 20px;
      margin-left: 0;
      margin-right: 0;
    }
    .landing__disclaimer-text {
      font-size: 15px;
    }
    .landing__provider-wrapper {
      flex-flow: wrap;
      justify-content: center;
    }
    .landing__provider-container {
      width: calc(50% - 20px);
    }
    .landing_logout {
      display: none;
    }
  }

  @media screen and (max-width: 544px) {
    .landing__provider-wrapper {
      flex-flow: wrap;
      justify-content: center;
    }
    .landing__provider-container {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;
